import { render, staticRenderFns } from "./MatterStudyEnvironment.vue?vue&type=template&id=6036064e&scoped=true"
import script from "./MatterStudyEnvironment.vue?vue&type=script&lang=js"
export * from "./MatterStudyEnvironment.vue?vue&type=script&lang=js"
import style0 from "./MatterStudyEnvironment.vue?vue&type=style&index=0&id=6036064e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6036064e",
  null
  
)

export default component.exports